<div class="pm-mobile-form-field-container">
  <ng-content select="[mobile-form-selector]">
    <div
      (click)="onMobileFormFieldClick()"
      (keyup.enter)="onMobileFormFieldClick()"
      class="pm-mobile-form-field-button"
      [id]="'pm-mobile-form-field-button-' + formField.name"
      role="presentation"
      [ngClass]="{ APPLIED: selectedValue }"
    >
      <div class="pm-mobile-form-field-button-label p3">
        <span>
          {{ formField.label }}
        </span>
        <span *ngIf="selectedValueLabel" class="selected-value-label">
          &nbsp;({{ selectedValueLabel }})
        </span>
      </div>
    </div>
  </ng-content>

  <pm-dialog
    [visible]="!!selectedFormField"
    [header]="selectedFormField?.label"
    (closeEvent)="onDialogCloseEvent()"
    (saveEvent)="onDialogSaveEvent()"
    [saveDisabled]="!this.ctrl.valid"
  >
    <pm-form-field
      [formField]="formField"
      [ctrl]="dialogControl"
      (monthChanged)="onMonthChanged($event)"
    />
  </pm-dialog>
</div>
